"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Number
    }
  },
  computed: {
    currentQuick: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    async handleQuickBtnClick(item) {
      this.$emit('change', item);
    }
  }
};